<div class="w-full flex flex-col items-center gap-10 lg:gap-120 mt-10 mb-20 pb-40">
  <tandem-financial-overview class="w-full"></tandem-financial-overview>
  <tandem-goals class="w-full"></tandem-goals>
</div>

